import React from 'react'
import DateComp from '../../../../../core/common/dateComponent/DateComp';
import FormattedNumber from '../../../../../core/common/textFields/FormatNumber';

const SummaryAddenda = ({ formikCreateAddendum, totalAddendaSaleAmt, salePriceAddendaPrice }: any) => {

  const totalContractAmount = (salePriceAddendaPrice?.salePrice || 0) + (salePriceAddendaPrice?.addendaPrice || 0);
  const formatComma = (num: number | string) => {
    if (num === null || num === undefined) return "0.0";
    const numericValue = String(num).replace(/,/g, "");
    if (isNaN(Number(numericValue))) return String(num);
    return Number(numericValue).toLocaleString();
  };

  const saleAmount = Number(formikCreateAddendum?.values?.saleAmount)
  const costAmount = Number(formikCreateAddendum?.values?.costAmount)
  const markup = Number(formikCreateAddendum?.values?.addendaMarkUp)
  const payableAmount = Number(formikCreateAddendum?.values?.amtPayableAcceptance)

  return (
    <>
      <div className='row'>
        <div className='col-md-12'>
          <h4 className='mt-3 mb-2'>Summary</h4>
        </div>
      </div>
      <div className='br-gray p-2'>
        <h5 className='mt-2 color-red mb-2'>Addendum Summary</h5>
        <div className='row'>
          <div className='col-md-6'>
            <div className='d-flex'>
              <p className='w-50 mb-0 fw-700'>
                Addenda Number :
              </p>
              <p>
                {formikCreateAddendum?.values?.addendaNbr}
              </p>
            </div>
          </div>
          <div className='col-md-6'>
            <div className='d-flex'>
              <p className='w-50 mb-0 fw-700'>
                Type :
              </p>
              <p>
                {formikCreateAddendum?.values?.addendaType?.value}
              </p>
            </div>
          </div>
          <div className='col-md-6 mt-2'>
            <div className='d-flex'>
              <p className='w-50 mb-0 fw-700'>
                Written By :
              </p>
              <p>
                {formikCreateAddendum?.values?.writtenBy?.value}

              </p>
            </div>
          </div>
          {/* <div className='col-md-6 mt-2'>
            <div className='d-flex'>
              <p className='w-50 mb-0'>
                Status :
              </p>
              <p>
                9999
              </p>
            </div>
          </div> */}
          <div className='col-md-6 mt-2'>
            <div className='d-flex'>
              <p className='w-50 mb-0 fw-700'>
                Addenda Date :
              </p>
              <p>
                <DateComp formattedDate={formikCreateAddendum?.values?.addendaDate} />
              </p>
            </div>
          </div>
          <div className='col-md-6 mt-2'>
            <div className=''>
              <p className='mb-0 fw-700'>
                Description:
              </p>
              <p>
                {formikCreateAddendum?.values?.desc}

              </p>
            </div>
          </div>
          <div className='col-md-6 mt-2'>
            <div className=''>
              <p className='mb-0 fw-700'>
                Internal Description :
              </p>
              <p>
                {formikCreateAddendum?.values?.internalDesc}

              </p>
            </div>
          </div>
        </div>
      </div>
      <div className='br-gray mt-3 p-2'>
        <h5 className='mt-2 color-red mb-2'>Approval Status</h5>
        <div className='row px-3'>
          {formikCreateAddendum?.values?.addendaStatus?.value || formikCreateAddendum?.values?.status}
        </div>
      </div>
      <div className='br-gray mt-3 p-2'>
        <h5 className='mt-2 color-red mb-2'>Financials & Impact</h5>
        <div className='row px-3'>
          <div className='col-md-6'>
            <p className='text-decoration-underline fw-700 mb-0'>Financials</p>
            <div className='d-flex '>
              <p className='mb-0 w-50 fw-700'>
                Addendum Sale Amount :
              </p>
              <p className='mb-0 w-50 '>
                <FormattedNumber value={saleAmount} />
              </p>
            </div>
            <div className='d-flex '>
              <p className='mb-0 w-50 fw-700'>
                Addendum Cost Amount :
              </p>
              <p className='mb-0 w-50 '>
                <FormattedNumber value={costAmount} />
              </p>
            </div>
            <div className='d-flex '>
              <p className='mb-0 w-50 fw-700'>
                Addendum Markup :
              </p>
              <p className='mb-0 w-50 '>
                {markup !== 0 && markup > 0 ? markup?.toFixed(2)?.toLocaleString() : '--'}
              </p>
            </div>
            <div className='d-flex '>
              <p className='mb-0 w-50 fw-700'>
                Amt Payable Upon Acceptance :
              </p>
              <p className='mb-0 w-50'>
                <FormattedNumber value={payableAmount} />
              </p>
            </div>
            <div className='d-flex '>
              <p className='mb-0 w-50 fw-700'>
                Total Contract Amount :
              </p>
              <p className='mb-0 w-50'>
                <FormattedNumber value={totalContractAmount} />
              </p>
            </div>
            <div className='d-flex '>
              <p className='mb-0 w-50 fw-700'>
                Total Payable Rcvd To Date :
              </p>
              <p className='mb-0 w-50'>
                { }

              </p>
            </div>
            <div className='d-flex '>
              <p className='mb-0 w-50 fw-700'>
                Open Balance :
              </p>
              <p className='mb-0 w-50 '>
                { }
              </p>
            </div>
          </div>
          <div className='col-md-6'>
            <p className='text-decoration-underline mb-0 fw-700'>Impact</p>
            <div className='d-flex '>
              <p className='mb-0 w-50 fw-700'>
                Contract Language :
              </p>
              <p className='mb-0 w-50 '>
                {formikCreateAddendum?.values?.isContractLanguage === true ? 'Yes' : 'No'}
              </p>
            </div>
            <div className='d-flex '>
              <p className='mb-0 w-50 fw-700'>
                TimeLine :
              </p>
              <p className='mb-0 w-50 '>
                {formikCreateAddendum?.values?.isTimeLine === true ? 'Yes' : 'No'}
              </p>
            </div>
            {formikCreateAddendum?.values?.isTimeLine === true &&
              <>
                <h6 className='text-decoration-underline'>TimeLine Impact Ranges</h6>
                <div className='d-flex '>
                  <p className='mb-0 w-50 fw-700'>
                    Internal :
                  </p>
                  <p className='mb-0 w-50 '>
                    {formikCreateAddendum?.values?.internalDurationTimeLine} Days
                  </p>
                </div>
                <div className='d-flex '>
                  <p className='mb-0 w-50 fw-700'>
                    External :
                  </p>
                  <p className='mb-0 w-50 '>
                    {formikCreateAddendum?.values?.externalDurationTimeLine} Days
                  </p>
                </div>
                <div className='d-flex '>
                  <p className='mb-0 w-50 fw-700'>
                    Phase Effected :
                  </p>
                  {(formikCreateAddendum?.values?.timeLineIsFieldProduction === true || formikCreateAddendum?.values?.timeLineIsProjDevelopment === true) &&
                    <p className='mb-0 w-50'>
                      {formikCreateAddendum?.values?.lst_SubstantialComplete?.value || formikCreateAddendum?.values?.lst_ContractReview?.value}
                    </p>
                  }
                </div>
              </>
            }
          </div>
        </div>
      </div>
    </>

  )
}

export default SummaryAddenda